import { render, staticRenderFns } from "./declareCustomsDialog.vue?vue&type=template&id=2f2704e4&"
import script from "./declareCustomsDialog.vue?vue&type=script&lang=js&"
export * from "./declareCustomsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2704e4')) {
      api.createRecord('2f2704e4', component.options)
    } else {
      api.reload('2f2704e4', component.options)
    }
    module.hot.accept("./declareCustomsDialog.vue?vue&type=template&id=2f2704e4&", function () {
      api.rerender('2f2704e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/routeCentral/declareCustomsDialog.vue"
export default component.exports